import { memo } from 'react';
import { useMatches } from 'react-router-dom';
import Typography from 'components/Typography';
import theme from 'theme';

function PageTitle(){
  const matches = useMatches();
  const pageTitle = matches[matches.length - 1]?.handle?.title;

  return(
    <Typography
      variant='h5'
      component='h2'
      sx={{
        color: theme.palette.primary.light,
        textTransform: 'uppercase'
      }}
    >
      {pageTitle}
    </Typography>
  )
} export default memo(PageTitle);